// import log from "../../logger";
import { ISolaceConsumer } from "./types/ISolaceConsumer";
import { queueBrowser } from "./queueBrowser";
const solace = require('solclientjs'); // logging supported

export class InitializeQueueBrowser {
    init(topicName: string, solaceCredentials: any, payload : string | null ) {
        // log.info(`Initializing queue consumer for queue ${topicName}`);
        console.log(`Initializing queue browser for queue ${topicName}`);
        // Initialize factory with the most recent API defaults
        const factoryProps = new solace.SolclientFactoryProperties();
        factoryProps.profile = solace.SolclientFactoryProfiles.version10;
        solace.SolclientFactory.init(factoryProps);

        // enable logging to JavaScript console at WARN level
        // NOTICE: works only with ('solclientjs').debug
        solace.SolclientFactory.setLogLevel(solace.LogLevel.WARN);

        // create the consumer, specifying the name of the queue
        const solaceEvents: ISolaceConsumer = queueBrowser(solace, topicName, solaceCredentials, payload);
 
        // log.info(`Queue consumer initialized for queue ${topicName}`);
        // subscribe to messages on Solace message router
        solaceEvents.run();

        // wait to be told to exit
        solaceEvents.log("Press Ctrl-C to exit");
        //process.stdin.resume();

        // process.on('SIGINT', function () {
        //     'use strict';
        //     consumer.exit();
        // });
        return solaceEvents
    }
}